import React from 'react'

const Footer = () => {
    return (
        <footer className='flex flex-col justify-center items-center py-5 text-xs text-gray-600 m-0'>
            <p>Copyright © Adventour 2020</p>
            <p>UA - Projeto realizado no âmbito da investigação SEDUCE 2.0 - miOne</p>
        </footer>
    )
}

export default Footer